import styled from 'styled-components';

export const SelectContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
